import React from "react";
import { styled, SxProps, Theme, useTheme } from "@mui/material";
import { ReactComponent as _CloudIcon } from "../../assets/images/cloud_icon.svg";

export const useEstimatorFormStyles = () => {
  const { breakpoints } = useTheme();
  const forms: SxProps = {
    display: "flex",
    flexDirection: "column"
  };

  const pdfForm: SxProps = {
    // height: "320px",
    minHeight: "320px",
    [breakpoints.down(1100)]: {
      height: "unset"
    }
  };

  const inputBoxes: SxProps = {
    background: "#fff",
    padding: "24px",
    borderRadius: "10px",
    gap: "8px"
  };

  const polymerFormLabel: SxProps = {
    minWidth: "110px",
    margin: 0,
    padding: "6px 6px"
  };

  const polymerCheckbox: SxProps = {
    color: "#D9D9D9 !important",
    "&.Mui-checked": {
      color: "#BFA66E !important"
    },
    "&.MuiCheckbox-root": {
      padding: 0,
      paddingRight: "4px"
    }
  };

  const mainWrapper: SxProps = {
    justifyContent: "space-between",
    height: "100%",
    alignItems: "center"
  };

  return {
    forms,
    pdfForm,
    inputBoxes,
    polymerFormLabel,
    polymerCheckbox,
    mainWrapper
  };
};
